import React from "react";
import "./RedLine.scss";

const RedLine = (props) => {
  return <div style={{ width: props.width }} className="red-line"></div>;
};

export default RedLine;
